import React, { Component } from 'react';
import { Button, modalConfirm } from 'components/antd';

interface DeleteBtnProps {
	itemId: string;
	onDelete: (itemId: string) => void;
}
class DeleteBtn extends Component<DeleteBtnProps> {
	showConfirmationModal = () => {
		const { itemId, onDelete } = this.props;

		modalConfirm({
			title: 'Delete this item?',
			content: 'You can not undo this action.',
			okText: 'Delete',
			onOk() {
				onDelete(itemId);
			},
		});
	};

	render() {
		return (
			<Button onClick={this.showConfirmationModal} isLink>
				Delete
			</Button>
		);
	}
}

export default DeleteBtn;
